/* ===== My Devilish Desires - Halloween seasonal theme (effects only; cursor is in theme.liquid) ===== */
(function(){
  if (window.__mddHW) return; window.__mddHW = true;
  var WEB = "data:image/svg+xml,%3Csvg%20xmlns%3D%27http%3A//www.w3.org/2000/svg%27%20viewBox%3D%270%200%20100%20100%27%3E%3Cg%20fill%3D%27none%27%20stroke%3D%27rgba%28240%2C235%2C236%2C0.4%29%27%20stroke-width%3D%271%27%3E%3Cpath%20d%3D%27M0%200%20L100%200%20M0%200%20L100%2046%20M0%200%20L70%2070%20M0%200%20L46%20100%20M0%200%20L0%20100%20M0%200%20L86%2020%20M0%200%20L20%2086%27/%3E%3Cpath%20d%3D%27M20%200%20Q15%2015%200%2020%20M44%200%20Q34%2034%200%2044%20M68%200%20Q54%2054%200%2068%20M92%200%20Q74%2074%200%2092%27/%3E%3C/g%3E%3C/svg%3E";
  var css = [
    '.mdd-hw-layer{position:fixed;inset:0;pointer-events:none;z-index:6;overflow:hidden;}',
    '.mdd-hw-bat{position:absolute;top:-8vh;will-change:transform;pointer-events:none;line-height:1;',
      'opacity:.5;filter:brightness(.22) drop-shadow(0 0 6px rgba(209,10,17,.7));',
      'animation-name:mddBat;animation-timing-function:linear;animation-iteration-count:infinite;}',
    '@keyframes mddBat{0%{transform:translate3d(0,-10vh,0) rotate(0deg);}',
      '35%{transform:translate3d(4vw,35vh,0) rotate(10deg);}',
      '70%{transform:translate3d(-3vw,72vh,0) rotate(-8deg);}',
      '100%{transform:translate3d(2vw,112vh,0) rotate(4deg);}}',
    '.mdd-hw-web{position:fixed;top:0;width:150px;height:150px;pointer-events:none;z-index:5;opacity:.55;',
      "background:no-repeat top center/contain;background-image:url('"+WEB+"');}",
    '.mdd-hw-web.l{left:0;}',
    '.mdd-hw-web.r{right:0;transform:scaleX(-1);}',
    '.mdd-hw-vig{position:fixed;inset:0;pointer-events:none;z-index:4;box-shadow:inset 0 0 200px 30px rgba(120,0,0,.30);}',
    '@media(max-width:600px){.mdd-hw-web{width:96px;height:96px;opacity:.4;}}',
    '@media(prefers-reduced-motion:reduce){.mdd-hw-bat{display:none;}}'
  ].join('');
  function boot(){
    var st=document.createElement('style'); st.setAttribute('data-mdd-hw','1'); st.textContent=css; document.head.appendChild(st);
    var vig=document.createElement('div'); vig.className='mdd-hw-vig'; document.body.appendChild(vig);
    var wl=document.createElement('div'); wl.className='mdd-hw-web l'; document.body.appendChild(wl);
    var wr=document.createElement('div'); wr.className='mdd-hw-web r'; document.body.appendChild(wr);
    var layer=document.createElement('div'); layer.className='mdd-hw-layer'; document.body.appendChild(layer);
    for(var i=0;i<7;i++){
      var b=document.createElement('div'); b.className='mdd-hw-bat'; b.textContent='🦇';
      var sz=(16+Math.random()*20); b.style.fontSize=sz.toFixed(0)+'px';
      b.style.left=(Math.random()*94).toFixed(1)+'vw';
      var dur=(12+Math.random()*12); b.style.animationDuration=dur.toFixed(1)+'s';
      b.style.animationDelay=(-Math.random()*dur).toFixed(1)+'s';
      layer.appendChild(b);
    }
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
})();

/* ===== My Devilish Desires - "See More" hover feedback + devil loading overlay ===== */
(function(){
  if (window.__mddSeeMore) return; window.__mddSeeMore = true;

  var DEVIL =
    '<svg viewBox="0 0 100 100" aria-hidden="true">'
    + '<path fill="#f00000" d="M30 36 C21 22 25 12 27 9 C31 20 37 27 42 31 C38 33 33 34 30 36 Z"/>'
    + '<path fill="#f00000" d="M70 36 C79 22 75 12 73 9 C69 20 63 27 58 31 C62 33 67 34 70 36 Z"/>'
    + '<path fill="#f00000" d="M50 28 C67 28 76 41 76 57 C76 76 64 88 50 88 C36 88 24 76 24 57 C24 41 33 28 50 28 Z"/>'
    + '<path fill="#0a0708" d="M37 53 L47 57 L37 59 Z"/>'
    + '<path fill="#0a0708" d="M63 53 L53 57 L63 59 Z"/>'
    + '</svg>';

  var css = [
    '.mdd-load{position:fixed;inset:0;z-index:99999;display:none;flex-direction:column;align-items:center;justify-content:center;gap:16px;background:rgba(10,7,8,.86);}',
    '.mdd-load.show{display:flex;}',
    '.mdd-load__box{position:relative;width:88px;height:88px;display:flex;align-items:center;justify-content:center;}',
    '.mdd-load__ring{position:absolute;inset:0;border-radius:50%;border:3px solid rgba(240,0,0,.18);border-top-color:#f00000;animation:mddSpin .8s linear infinite;}',
    '.mdd-load__devil{width:52px;height:52px;animation:mddPulse 1.1s ease-in-out infinite;filter:drop-shadow(0 0 8px rgba(240,0,0,.65));}',
    '.mdd-load__devil svg{width:100%;height:100%;display:block;}',
    '.mdd-load__txt{color:#fff;font-family:var(--heading-family,Georgia,serif);letter-spacing:.02em;font-size:15px;opacity:.92;}',
    '@keyframes mddSpin{to{transform:rotate(360deg);}}',
    '@keyframes mddPulse{0%,100%{transform:scale(.9);}50%{transform:scale(1.06);}}',
    '.mdd-seemore{transition:background-color .18s ease, box-shadow .18s ease, transform .18s ease !important;}',
    '.mdd-seemore:hover{background-color:#8a0000 !important;box-shadow:0 0 20px rgba(240,0,0,.55) !important;transform:translateY(-1px);}',
    '@media(prefers-reduced-motion:reduce){.mdd-load__ring,.mdd-load__devil{animation:none;}}'
  ].join('');

  var overlay, scheduled=false;

  function injectCSS(){ var s=document.createElement('style'); s.setAttribute('data-mdd-seemore','1'); s.textContent=css; document.head.appendChild(s); }
  function ensureOverlay(){
    if(overlay) return overlay;
    overlay=document.createElement('div'); overlay.className='mdd-load';
    overlay.innerHTML='<div class="mdd-load__box"><div class="mdd-load__ring"></div><div class="mdd-load__devil">'+DEVIL+'</div></div><p class="mdd-load__txt">Summoning more…</p>';
    document.body.appendChild(overlay); return overlay;
  }
  function show(){ ensureOverlay().classList.add('show'); }
  function hide(){ if(overlay) overlay.classList.remove('show'); }

  function isSeeMore(el){
    if(!el || !el.textContent) return false;
    var t=el.textContent.replace(/\s+/g,' ').trim().toLowerCase();
    return t==='see more' || t==='load more' || t==='show more' || t==='view more';
  }
  function cardCount(){ return document.querySelectorAll('product-item,.product-collection,.product-card').length; }
  function tag(){
    var els=document.querySelectorAll('a,button');
    for(var i=0;i<els.length;i++){ if(isSeeMore(els[i])) els[i].classList.add('mdd-seemore'); }
  }
  function scheduleTag(){ if(scheduled) return; scheduled=true; requestAnimationFrame(function(){ scheduled=false; tag(); }); }

  function onClick(e){
    var el=e.target && e.target.closest ? e.target.closest('a,button') : null;
    if(!el || !(el.classList.contains('mdd-seemore') || isSeeMore(el))) return;
    var base=cardCount(); show();
    var done=false, t;
    function finish(){ if(done) return; done=true; hide(); try{obs.disconnect();}catch(_){} clearTimeout(t); }
    var obs=new MutationObserver(function(){ if(cardCount()>base) finish(); });
    obs.observe(document.body,{childList:true,subtree:true});
    t=setTimeout(finish,12000);
  }

  function boot2(){
    injectCSS(); tag(); ensureOverlay();
    document.addEventListener('click', onClick, true);
    var mo=new MutationObserver(scheduleTag); mo.observe(document.body,{childList:true,subtree:true});
    window.addEventListener('pageshow', hide);
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot2);}else{boot2();}
})();
